import Grid from '@mui/material/Grid'
import Icon from '@mui/material/Icon'
import Paper from '@mui/material/Paper'
import { alpha } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import { getImageURL } from 'lib/utils'
import ChipCategory from './ChipCategory'
import ChipShow from './ChipShow'
import ChipStation from './ChipStation'
import * as gtag from 'lib/gtag'

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3)
  },
  chips: {
    display: 'flex',
    justifyContent: 'flext-start',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  description: {
    marginBottom: '20px',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-word'
  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  preview: {
    position: 'relative',
    display: 'block',
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '400px',
      height: '100%',
      marginBottom: theme.spacing(3)
    }
  },
  image: {
    display: 'block',
    backgroundColor: 'white',
    width: '400px',
    height: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '400px'
    }
  },
  text: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(3)
    }
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    textAlign: 'center',
    backgroundColor: '#4b4b4b',
    height: '100%',
    width: '100%',
    opacity: 0.3
  },
  play: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    top: 0,
    right: 0,
    margin: 'auto',
    fontSize: '60px',
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.text.primary, 0.8),
    borderRadius: '50%',
    width: '80px',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme.palette.text.primary
    },
    transition: 'background-color .3s ease-in-out'
  },
  clickMeWrapper: {
    position: 'absolute',
    top: '80%',
    left: 0,
    right: 0,
    margin: 'auto',
    textAlign: 'center',
    fontWeight: 'bold'
  },
  clickMe: {
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: '2px'
  },
  row: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  fieldLabel: {
    float: 'left',
    width: '120px',
    fontWeight: 'bold'

  }
}))

export default function ShowDetails ({ show, hideChips = false, headerTag = 'h1' }) {
  const classes = useStyles()

  const playVideo = () => {
    gtag.event('video_abspielen')
  }

  return (
    <Paper className={classes.paper}>
      <Grid container>
        <Grid item xs={12} className={classes.title}>
          <Typography
            variant='h3'
            component={headerTag}
            data-test='full-title'
            dangerouslySetInnerHTML={{ __html: show.fullTitle }}
          />
          <Typography variant='body2' component='p' color='textSecondary' gutterBottom data-test='date'>vom {show.date}</Typography>
        </Grid>
        {
          !hideChips &&
            <Grid item xs={12} className={classes.chips}>
              <ChipStation name={show.stations[0].name} slug={show.stations[0].slug} className={classes.chip} />
              <ChipCategory name={show.categories[0].name} slug={show.categories[0].slug} className={classes.chip} />
              <ChipShow name={show.series.name} slug={show.series.slug} className={classes.chip} />
            </Grid>
        }
        <Grid item xs={12} className={classes.content}>
          <a
            onClick={playVideo}
            href={redirectURL(show.id)}
            rel='noopener noreferrer nofollow'
            className={`video-link ${classes.preview}`}
            id='video-link'
            data-test='preview'
            title='Video abspielen'
            aria-label='Video abspielen'
          >
            <img
              src={getImageURL(show.image, show.stations[0].slug)}
              className={classes.image}
              title={show.fullTitle}
              alt={show.fullTitle}
              width='400'
              height='225'
            />
            <Icon className={classes.play}>play_arrow</Icon>
            <span className={classes.clickMeWrapper}>
              <span className={classes.clickMe}>
                Hier klicken um das Video abzuspielen
              </span>
            </span>
          </a>
          <Typography variant='body1' component='div' className={classes.text}>
            {
              show.description &&
                <div
                  className={classes.description}
                  dangerouslySetInnerHTML={{ __html: show.description }}
                />
            }
            <div className={classes.row}>
              <div className={classes.fieldLabel}>Sender:</div>
              <div>{show.stations[0].name}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.fieldLabel}>Sendedatum:</div>
              <div>{show.date}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.fieldLabel}>L&auml;nge:</div>
              <div>{show.duration} min</div>
            </div>
            <div className={classes.row}>
              <div className={classes.fieldLabel}>Aufrufe:</div>
              <div data-test='clicks'>{show.clicks ? show.clicks.toLocaleString('de-DE') : 0}</div>
            </div>
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  )
}

function redirectURL (id) {
  return '/api/view/' + id
}
